/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Script_Name_LabelInputs */



/**
* | output |
* | --- |
* | "Script Name" |
*
* @param {Image_Export_Script_Name_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_script_name_label = /** @type {((inputs?: Image_Export_Script_Name_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Script_Name_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nom du script")
	if (locale === "de") return /** @type {LocalizedString} */ ("Skriptname")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nome dello script")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Название скрипта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nombre del script")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("脚本名称")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スクリプト名")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्क्रिप्ट का नाम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nome do roteiro")
	return /** @type {LocalizedString} */ ("Script Name")
});